import React from 'react'
import { downloadPDF } from '../../pages/policy/utils'
import { Icon } from '../Icon'
import UiPdfViewer from '../UiPdfViewer'
import Modal from './UIModal'

interface CustomModalProps {
  isOpen: boolean
  onClose: () => void
  title: string

  url: string
  showButtons?: boolean
  onReject?: () => void
  onAccept?: () => void
}

const PdfViewer: React.FC<CustomModalProps> = ({
  isOpen,
  onClose,
  title,
  url,
  showButtons = false,
  onReject,
  onAccept
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        className={
          'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
        }
      >
        <div
          onClick={onClose}
          className="flex w-[100%] justify-end cursor-pointer"
        >
          <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
        </div>

        <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
          <h1 className={'text-text2 text-[18px] font-bold'}>{title}</h1>
          <UiPdfViewer url={url} />
        </div>
        {showButtons && (
          <>
            <div className="flex flex-row w-[100%] justify-evenly">
              <button
                onClick={onAccept}
                className="text-white bg-green border-green border-[1px] min-h-[48px] w-[35%] font-medium rounded-[72px] text-[14px]"
              >
                Accept
              </button>


              <button
                onClick={onReject}
                className="text-white bg-textError border-textError border-[1px] min-h-[48px] w-[35%] font-medium rounded-[72px] text-[14px]"
              >
                Reject
              </button>
            </div>
          </>
        )}

        <button
          onClick={() => {
            downloadPDF(url, 'data.pdf')
          }}
          className="text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]"
        >
          Download
        </button>
      </div>
    </Modal>
  )
}

export default PdfViewer
